// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-tabs[data-v-4e711df2] {\n    border-bottom: 1px solid #e0e0e0;\n}\n", ""]);
// Exports
module.exports = exports;
